import { render, staticRenderFns } from "./AreaRegionCatalogList.vue?vue&type=template&id=73fab766&"
import script from "./AreaRegionCatalogList.vue?vue&type=script&lang=js&"
export * from "./AreaRegionCatalogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports